import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button'
import { Grid, Box } from '@mui/material'
import { addDays, format } from 'date-fns'
import { facilityData } from '../Store'
import { useAuth } from '../contexts/AuthContext'

const Header = (props) => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - prpos
	//-----------------------------------------------
    const { loginInfo, backButton, backPage } = props

	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }  = useAuth()
    const userName      = authInfo.userName
    const authorityName = authInfo.authorityName
    
    const navigate     = useNavigate()
    const today        = format(addDays(new Date(), 0), 'yyyy-MM-dd')

	//-----------------------------------------------
	// Cookieに保存したデータを削除する
	//-----------------------------------------------
    const CookieDataDelete = () => {
        sessionStorage.removeItem('isAuthenticated')
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('facilityCode')
        sessionStorage.removeItem('facilityName')
        sessionStorage.removeItem('userId')
        sessionStorage.removeItem('userName')
        sessionStorage.removeItem('userNameDsp')
        sessionStorage.removeItem('authority')
        sessionStorage.removeItem('traderCode')
        sessionStorage.removeItem('trader')
    }
    //===============================================
    // CSS
    //===============================================
    const header = {
        width          : '100%',
        height         : '50px',
        maxHeight      : '160px',
        display        : 'flex',
        justifyContent : 'space-between',
        alignItems     : 'center'
    }
    const header_pageTitle = {
        color      : '#305496',
        fontSize   : '1.5rem',
        fontWeight : '1000',
        marginLeft : '1rem',
        marginRight : '1rem',
        fontWeight : 'bold'
    }
    const header_flex = {
        display    : 'flex',
        marginLeft : '20px',
        width:'300px'
    }
    const header_userInfo = {
        fontSize   : '1.0rem',
        fontWeight : '1000',
        padding    : '7px',
        textAlign  : 'left',
    }
    const header_date = {
        marginLeft   : '0px',
        marginRight  : '20px',
        padding      : '7px 10px 5px 10px',
        height       : '37px',
        borderRadius : '10px',
        background   : '#fff',
        color        : '#305496',
        border       : '1px solid #305496',
        fontSize     : '15px',
        width        : '120px'
    }
    //===============================================
	// JSXのレンダー
    //===============================================
    return (
        <>
            <header style={ header } className='no-print'>
                <Box display="flex" justifyContent="space-between" sx={{mt:1}}>
                    <div style={ header_flex }>
                        <img src={`${process.env.PUBLIC_URL}${ facilityData.logoUrl }`} style={{height:'40px', width:'50px'}} />  
                        <a href="#" className="pagetitle" style={ header_pageTitle }>{ '京都府漁業協同組合' }</a>
                    </div>
                    <div style={{display:'flex', width:'320px'}}>
                        <div style={ header_userInfo }>
                            {loginInfo == 'on'
                                ?
                                `ログイン：${ userName }(${ authorityName })`
                                : <></>
                            }
                        </div>
                    </div>
                    <div style={{display:'flex', width:'110px'}}>
                        <div>
                            {loginInfo == 'on'
                            ? 
                            <div style={header_date}>{ today }</div>
                            : <></>
                            }
                        </div>
                    </div>
                    <div style={{display:'flex', width:'110px'}}>
                        {backButton == 'on'
                            ? 
                            <Button
                                variant="contained"
                                style={{color:'#fff', marginLeft:'40px'}}
                                onClick={() => {
                                    backPage == 'prev' ? navigate(-1) : navigate(backPage)
                                }}
                                >
                                戻る
                            </Button>
                            : <></>
                        }
                    </div>
                    <div style={{display:'flex', width:'120px'}}>
                        {loginInfo == 'on'
                        ? 
                            <Button
                                variant="contained"
                                style={{color:'#fff', marginLeft:'10px'}}
                                onClick={() => {
                                    CookieDataDelete()
                                    navigate('/')
                                }}
                                >
                                ログアウト
                            </Button>
                        : <></>
                        }
                    </div>
                </Box>
            </header>
        </>
    );
}

export default Header